import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Compass, Music, MessageCircle, User, Settings } from 'lucide-react';

function Navbar() {
  const location = useLocation();
  
  return (
    <nav className="mobile-nav">
      <div className="mobile-nav-content grid grid-cols-6">
        <Link 
          to="/" 
          className={`mobile-nav-link ${
            location.pathname === '/' ? 'text-indigo-600' : 'text-gray-600'
          }`}
        >
          <div className="mobile-nav-icon">
            <Home className="w-full h-full" />
          </div>
          <span className="mobile-nav-label">Feed</span>
        </Link>

        <Link 
          to="/explore" 
          className={`mobile-nav-link ${
            location.pathname === '/explore' ? 'text-indigo-600' : 'text-gray-600'
          }`}
        >
          <div className="mobile-nav-icon">
            <Compass className="w-full h-full" />
          </div>
          <span className="mobile-nav-label">Explore</span>
        </Link>

        <Link 
          to="/compare" 
          className={`mobile-nav-link ${
            location.pathname === '/compare' ? 'text-indigo-600' : 'text-gray-600'
          }`}
        >
          <div className="mobile-nav-icon">
            <Music className="w-full h-full" />
          </div>
          <span className="mobile-nav-label">Compare</span>
        </Link>

        <Link 
          to="/chat" 
          className={`mobile-nav-link ${
            location.pathname === '/chat' ? 'text-indigo-600' : 'text-gray-600'
          }`}
        >
          <div className="mobile-nav-icon">
            <MessageCircle className="w-full h-full" />
          </div>
          <span className="mobile-nav-label">Chat</span>
        </Link>

        <Link 
          to="/profile" 
          className={`mobile-nav-link ${
            location.pathname === '/profile' ? 'text-indigo-600' : 'text-gray-600'
          }`}
        >
          <div className="mobile-nav-icon">
            <User className="w-full h-full" />
          </div>
          <span className="mobile-nav-label">Profile</span>
        </Link>

        <Link 
          to="/settings" 
          className={`mobile-nav-link ${
            location.pathname === '/settings' ? 'text-indigo-600' : 'text-gray-600'
          }`}
        >
          <div className="mobile-nav-icon">
            <Settings className="w-full h-full" />
          </div>
          <span className="mobile-nav-label">Settings</span>
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;